import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  FieldworkAudienceV2Query,
  FieldworkAudienceV2QueryVariables
} from '../../data/gql-gen/questionnaire/graphql'
import { FIELDWORK_AUDIENCE_V2 } from '../../data/gql/questionnaire/queries/fieldworkAudience'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { useSurveyId } from '../useSurveyId'

export const useFieldworkAudience = (
  options?: QueryHookOptions<
    FieldworkAudienceV2Query,
    FieldworkAudienceV2QueryVariables
  >
) => {
  const surveyId = useSurveyId()

  const { data, loading, error, refetch } = useQuery<
    FieldworkAudienceV2Query,
    FieldworkAudienceV2QueryVariables
  >(FIELDWORK_AUDIENCE_V2, {
    ...options,
    context: { clientName: 'questionnaire' },
    variables: { surveyId },
    skip: options?.skip !== undefined ? options.skip : !surveyId,
    onError: (error) => {
      captureApolloError(
        LoggerErrorType.ApolloQuery,
        'fieldworkAudienceV2',
        error
      )
    }
  })

  return {
    fieldworkAudience: data?.fieldworkAudienceV2,
    loading,
    error,
    refetch
  }
}
